export class ChatError extends Error {
    status: number;

    constructor(status: number, statusText: string) {
        super(statusText);
        this.status = status;
    }
}
